import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
  state: () => {
    return {
      feedback: false,
      glossary: false,
    };
  },
});
